import script from "./ConferenceView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConferenceView.vue?vue&type=script&setup=true&lang=js"

import "./ConferenceView.vue?vue&type=style&index=0&id=cd5c9be0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd5c9be0"]])

export default __exports__